import React from "react";
import { Box, Typography } from "@mui/material";
import "./BackdropOverlay.css";
import NavItems from "../templates/NavItems";

const OverlayModal = (props) => {
  return (
    <Box className="modal">    
      {props.title.substr("NavItems") ? (
        <NavItems title={props.title} content={props.content} onClose={props.onClose}/>
      ) : (
        <Box>
          <Typography className="header" variant="h4">
            {props.title}
          </Typography>
          <Typography className="content" variant="p">
            {props.content}
          </Typography>
        </Box>
      )}
    </Box>
  );
};
export default OverlayModal;
